<template>
  <div>
    <!-- <a-form
      layout="inline"
      :model="seekData"
      ref="seekForm"
      class="ant-advanced-search-form"
    >
      <a-form-item label="报告名称">
        <a-input
          v-model="seekData.keyword"
          placeholder="请输入报告名称关键词"
        />
      </a-form-item>
      <a-form-item label="报告日期">
        <a-range-picker
          :show-time="showTime"
          :value="seekData.time"
          valueFormat="YYYY-MM-DD"
          :placeholder="['开始时间', '结束时间']"
          @ok="timeChange"
        />
      </a-form-item>
      <a-form-item>
        <a-button class="mr10" type="primary" icon="search" @click="doSeek">
          查询
        </a-button>
        <a-button @click="removeSeek" icon="reload"> 重置 </a-button>
      </a-form-item>
    </a-form> -->

    <!-- el版 -->
    <el-form :inline="true" ref="seekData" :model="seekData" class="ant-advanced-search-form">
      <el-form-item label="报告名称">
        <el-input v-model="seekData.keyword" placeholder="请输入报告名称关键词"></el-input>
      </el-form-item>


      <el-form-item label="报告日期">
        <el-date-picker v-model="seekData.time" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="doSeek">查询</el-button>
        <el-button icon="el-icon-refresh" @click="removeSeek('seekData')">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="alnCt mt20" style="color: #ffffff">
      <div @click="changeBtn(1)" :class="showType == 1 ? 'fxjg-btn-select' : 'fxjg-btn'">
        视频（{{ classifyNumVo.videoNum || 0 }}）
      </div>
      <div @click="changeBtn(2)" :class="showType == 2 ? 'fxjg-btn-select' : 'fxjg-btn'">
        图片（{{ classifyNumVo.imgNum || 0 }}）
      </div>
      <!-- <div @click="changeBtn(3)" :class="showType == 3 ? 'fxjg-btn-select' : 'fxjg-btn'" >
        文件（{{ classifyNumVo.fileNum || 0 }}）
      </div> -->
    </div>

    <a-empty v-if="list.length <= 0" :image="simpleImage" />

    <div class="videoCont" v-if="showType == 1 && list.length">
      <div class="videoItem" v-for="(item, index) in list" :key="index">
        <div class="videoCover" @click="playVideo(item)">
          <video :src="item.filePath" :width="300" :height="150"></video>
          <div class="videoMask">
            <a-icon type="play-circle" theme="filled" style="font-size: 28px" />
            <div class="mt5">{{ formatLength(item.videoLength) }}</div>
          </div>
        </div>
        <div class="mt10 elpss">{{ item.title }}-{{ item.videoType }}</div>
        <div class="info">
          <div class="flxL">
            <a-avatar size="small" :src="item.headImageUrl"></a-avatar>
            <span>{{ item.name }}</span>
          </div>
          <div class="flxR txt-gray size12">
            {{ moment(item.createTime).format("yyyy-MM-DD") }}
          </div>
        </div>
      </div>
    </div>
    <div class="videoCont" v-if="showType == 2 && list.length">
      <div class="videoItem" v-for="(item, index) in list" :key="index">
        <div class="wz-position-relative wz-radius-1 wz-overflow-hidden cover">
          <img :src="item.filePath" alt="" />
        </div>
        <div class="mt10 itemTit elpss">{{ item.title }}</div>
        <div class="info">
          <div class="flxL">
            <a-avatar size="small" :src="item.headImageUrl"></a-avatar>
            <span>{{ item.name }}</span>
          </div>
          <div class="flxR txt-gray size12">
            {{ moment(item.createTime).format("yyyy-MM-DD") }}
          </div>
        </div>
      </div>
    </div>
    <div class="videoCont margin-b30" v-if="showType == 3 && list.length">
      <a-table :dataSource="list" :columns="columns" :pagination="false" style="width: 100%">
        <template #name="{ record }">
          <div class="flex-s-c">
            <img :src="record.headImageUrl" class="avatar" />
            <span class="margin-l10">{{ record.name }}</span>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="flxCC">
            <a-button type="primary" ghost @click="download(record)">
              下载
            </a-button>
          </div>
        </template>
      </a-table>
    </div>
    <div class="flxEnd">
      <!-- <a-pagination
        show-quick-jumper
        show-size-changer
        :total="total"
        :current="seekData.pageNum"
        :page-Size="seekData.pageSize"
        @change="changePage"
        @showSizeChange="showSizeChange"
      /> -->
      <pagination :total="total" :page.sync="seekData.pageNum" :limit.sync="seekData.pageSize" @pagination="getList" />
    </div>
    <VideoPlay :fileUrl="video_url" :coverUrl="coverUrl" :show="video_show" @change="closeVideo" />
  </div>
</template>
<script>
import moment from "moment";
import { Empty } from "ant-design-vue";
import VideoPlay from "@/components/training/videoPlay";
// import { getReportList, getPlayUrls } from "@/common/api/api.js";
import * as API_Member from "@/api/train/member";
export default {
  inject: ["getId"],
  components: {
    VideoPlay,
  },
  computed: {
    id() {
      return this.getId();
    },
    changeTime() {
      return function (time, type) {
        type = type ? type : "YYYY-MM-DD HH:mm:ss";
        return moment(time).format(type);
      };
    },
    videoTime() {
      return function (mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = parseInt((mss % (1000 * 60)) / 1000);
        if (days > 0) {
          return `${days}天${hours < 10 ? "0" + hours : hours}小时${
            minutes < 10 ? "0" + minutes : minutes
          }分钟${seconds < 10 ? "0" + seconds : seconds}秒`;
        }
        if (hours > 0) {
          return `${hours < 10 ? "0" + hours : hours}:${
            minutes < 10 ? "0" + minutes : minutes
          }:${seconds < 10 ? "0" + seconds : seconds}`;
        }
        return `${minutes < 10 ? "0" + minutes : minutes}:${
          seconds < 10 ? "0" + seconds : seconds
        }`;
      };
    },
    moment: () => moment,
    formatLength() {
      return (num) => {
        const min = Math.floor(parseInt(num) / 1000 / 60);
        const sec = Math.floor(parseInt(num) / 1000 - 60 * min);
        return `${min.toString().padStart(2, "0")}:${sec
          .toString()
          .padStart(2, "0")}`;
      };
    },
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      video_icon: require("@/assets/train/video.png"),
      showTime: {
        format: "HH:mm:ss",
        defaultValue: [
          moment("00:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
        ],
      },
      columns: [
        {
          title: "序号",
          dataIndex: "a1",
          key: "a1",
          align: "center",
          customRender: (val, record, index) => index + 1,
        },
        {
          title: "文件名称",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "类型",
          dataIndex: "suffix",
          key: "suffix",
        },
        {
          title: "文件大小",
          dataIndex: "fileSize",
          key: "fileSize",
          customRender: function (val) {
            if (val) {
              val = parseInt(val);
              if (val < 1024) {
                val = val + "B";
              } else if (val < 1024 * 1024) {
                val = (val / 1024).toFixed(2) + "KB";
              } else {
                val = (val / 1024 / 1024).toFixed(2) + "MB";
              }
            }
            return val;
          },
        },
        {
          title: "上传时间",
          dataIndex: "createTime",
          key: "createTime",
          align: "center",
          customRender: (val) => {
            return val ? moment(val).format("yyyy-MM-DD HH:mm:ss") : "";
          },
        },
        {
          title: "操作",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      seekData: {
        keyword: null,
        pageNum: 1,
        pageSize: 10,
        time: [],
        startTime: null,
        endTime: null,
      },
      total: 10,
      list: [],
      classifyNumVo: {},
      showType: 1, // 1-视频 2-图片 3-文档
      video_url: "",
      video_show: false,
      videoTypeObj: {
        1: "比赛",
        2: "训练",
        3: "分析",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    timeChange(e) {
      console.log("timeChange");
      console.log(e);
      this.seekData.time = e;
    },
    closeVideo() {
      this.video_show = false;
    },
    playVideo(e) {
      let jsone = JSON.parse(JSON.stringify(e));
      if (jsone.videoId) {
        API_Member.getPlayUrls(jsone.videoId)
          .then((res) => {
            if (res.data) {
              this.video_show = true;
              this.video_url = res.data.playInfoList[0].playURL;
              this.coverUrl = res.data.videoBase.coverURL;
            } else {
              this.video_show = true;
              this.video_url = jsone.drillVideoPath;
              this.coverUrl = "";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.video_show = true;
        this.video_url = jsone.drillVideoPath;
        this.coverUrl = "";
      }
    },

    changeBtn(type) {
      this.showType = type;
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    // 切换分页
    changePage(current, pageSize) {
      this.seekData.pageNum = current;
      this.seekData.pageSize = pageSize;
      this.getList();
    },
    showSizeChange(current, pageSize) {
      this.seekData.pageNum = current;
      this.seekData.pageSize = pageSize;
      this.getList();
    },
    // 点击搜索
    doSeek() {
      this.seekData.pageNum = 1;
      this.getList();
    },
    // 重置
    removeSeek(formName) {
      Object.keys(this.seekData).forEach((key) => {
        if (key != "time") {
          this.seekData[key] = null;
        } else {
          this.seekData[key] = [];
        }
      });
      this.$refs[formName].resetFields();
      this.seekData.pageNum = 1;
      this.seekData.pageSize = 10;
      this.getList();
    },
    getList() {
      let params = {
        memberId: this.id,
        fileType: this.showType,
        ...this.seekData,
      };
      console.log(params);
      if (params.time && params.time.length) {
        params.startTime = moment(params.time[0]).valueOf();
        const end = new Date(moment(this.seekData.time[1]).valueOf());
        params.endTime = +new Date(
          end.getFullYear(),
          end.getMonth(),
          end.getDate(),
          23,
          59,
          59,
        );
      }
      API_Member.getReportList(params)
        .then((res) => {
          console.log(res.data);
          let result = res.data;
          this.classifyNumVo = result.classifyNumVo;
          if (this.showType == 1) {
            this.list = result.videoPageData.list;
            this.total = result.videoPageData.total;
          }
          if (this.showType == 2) {
            this.list = result.picturePageData.list;
            this.total = result.picturePageData.total;
          }
          if (this.showType == 3) {
            this.list = result.filePageData.list;
            this.total = result.filePageData.total;
          }
        })
        .catch((err) => {});
    },
    download(e) {
      console.log(e);
      let a = document.createElement("a");
      a.href = e.filePath;
      a.download = e.fileName;
      a.click();
    },
  },
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";
.videoCont {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.videoItem {
  width: 320px;
  margin: 0 20px 20px 0;
  color: #ffffff;
  cursor: pointer;
  .cover {
    width: 320px;
    height: 180px;
    color: #ffffff;
    img,
    video {
      width: 100%;
      height: 100%;
    }
    img {
      border-radius: 10px;
      object-fit: scale-down;
      background-color: #fafafa;
    }
  }

  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    color: #999;
    span{
      margin-right: 5px;
    }
    span:last-child{
      margin-right: 0;
    }
  }

  .ant-avatar {
    margin-right: 4px;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.videoCover {
  position: relative;
  width: 320px;
  height: 180px;
  border-radius: 4px;
  overflow: hidden;
}
.videoMask {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 320px;
  height: 180px;
  padding-top: 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
}
.fxjg-btn {
  height: 40px;
  line-height: 40px;
  margin-right: 20px;
  width: 110px;
  text-align: center;
  border-radius: 4px;
  // background: #282f54;
  cursor: pointer;
}
.fxjg-btn-select {
  height: 40px;
  line-height: 38px;
  margin-right: 20px;
  color: #1890ff;
  border: 1px solid #1890ff;
  border-radius: 4px;
  width: 110px;
  text-align: center;
  cursor: pointer;
}
::v-deep.cover-img.ant-image-img {
  width: 340px;
  height: 191px;
  object-fit: cover;
}
</style>
